import { memo } from "react";
import { useTranslation } from "react-i18next";
import { AuraLayout, Layout, PageTitle } from "lola-framework-ui-test";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { RotateDeviceIcon } from "../../components/RotateDeviceIcon";
import { TITLE_COLOR } from "../../constants";
import { useStore } from "../../store/globalState";

/**
 * Gallery copy of the portrait orientation guard. Always visible (no
 * landscape hook) so it can be inspected on desktop. Disc + title sit on the
 * shared `flow-hero` anchor, so the mark lands on the same center as the
 * welcome / verifying screens instead of the middle of the viewport.
 */
export const RotateToPortraitPage = memo(() => {
  const { t } = useTranslation("starter");
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const { dropzoneColors, backgroundIcon } = colorConfig;

  return (
    <AuraLayout colorConfig={colorConfig} className="rotate-to-portrait-page">
      <Layout.Content className="landing-section flow-hero-section rotate-to-portrait-section">
        <section className="flow-hero">
          <FlowHeroMark backgroundIcon={backgroundIcon}>
            <RotateDeviceIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("orientation.title")}
              highlightColor={TITLE_COLOR}
              secudnary={t("orientation.subtitle")}
              secudnaryColor={TITLE_COLOR}
            />
          </section>
        </section>
      </Layout.Content>
    </AuraLayout>
  );
});
